import type { SortTabList } from "./types";

/**
 * Reorders a tab list for display only. "smart" preserves the source order
 * (which is already prefix-grouped, quantity-descending from the transform).
 * "quantity" sorts by the numeric quantity descending; "name" sorts the label
 * lexicographically. Never mutates the input array.
 */
export const sortTabList: SortTabList = ({
  items,
  mode,
  getLabel,
  getQuantity,
}) => {
  if (mode === "name") {
    return [...items].sort((firstItem, secondItem) =>
      getLabel(firstItem).localeCompare(getLabel(secondItem)),
    );
  }

  if (mode === "quantity") {
    return [...items].sort(
      (firstItem, secondItem) =>
        getQuantity(secondItem) - getQuantity(firstItem),
    );
  }

  return items;
};
